<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { dynamicTime } from 'shared/helpers/timeHelper';

import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  scheduledMessage: { type: Object, required: true },
});

const emit = defineEmits(['edit', 'cancel', 'sendNow']);

const { t } = useI18n();

const isPending = computed(() => props.scheduledMessage.status === 'pending');

const timeLabel = computed(() =>
  dynamicTime(
    isPending.value
      ? props.scheduledMessage.scheduled_at
      : props.scheduledMessage.sent_at
  )
);
</script>

<template>
  <div class="flex flex-col gap-2 p-3 rounded-lg border border-n-weak">
    <div class="flex gap-2 justify-between items-start">
      <p class="mb-0 text-sm break-words text-n-slate-12 line-clamp-3">
        {{ scheduledMessage.content }}
      </p>
      <span
        v-if="scheduledMessage.private"
        class="px-1.5 py-0.5 text-xs rounded shrink-0 bg-n-amber-3 text-n-amber-11"
      >
        {{ t('CONVERSATION.SCHEDULED_MESSAGES.PRIVATE') }}
      </span>
    </div>

    <p
      v-if="scheduledMessage.attachments.length"
      class="mb-0 text-xs text-n-slate-11"
    >
      {{
        t('CONVERSATION.SCHEDULED_MESSAGES.ATTACHMENTS', {
          count: scheduledMessage.attachments.length,
        })
      }}
    </p>

    <span class="text-xs text-n-slate-11">{{ timeLabel }}</span>

    <div v-if="isPending" class="flex gap-2">
      <Button
        faded
        slate
        xs
        :label="t('CONVERSATION.SCHEDULED_MESSAGES.SEND_NOW')"
        @click="emit('sendNow', scheduledMessage)"
      />
      <Button
        faded
        slate
        xs
        :label="t('CONVERSATION.SCHEDULED_MESSAGES.EDIT')"
        @click="emit('edit', scheduledMessage)"
      />
      <Button
        faded
        ruby
        xs
        :label="t('CONVERSATION.SCHEDULED_MESSAGES.CANCEL')"
        @click="emit('cancel', scheduledMessage)"
      />
    </div>
  </div>
</template>
